import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Icons from 'lucide-react';
import SiteNav from './marketing/SiteNav';
import SiteFooter from './marketing/SiteFooter';
import { Button } from './ui/button';
import { api } from '../api';

const Icon = ({ name, className }) => { const C = Icons[name] || Icons.Circle; return <C className={className} />; };

const Services = () => {
  const navigate = useNavigate();
  const [pillars, setPillars] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get('/services').then((r) => { setPillars(r.data); setActive(r.data[0]?.id); });
  }, []);

  const pillar = pillars.find((p) => p.id === active);
  const book = (optionId) => navigate(`/book?option=${optionId}`);

  return (
    <div className="min-h-screen bg-background">
      <SiteNav />
      <section className="hero-gradient pt-[68px]">
        <div className="max-w-7xl mx-auto px-6 py-16 text-white">
          <h1 className="font-display font-extrabold text-4xl md:text-5xl">Our services</h1>
          <p className="mt-4 text-slate-300 max-w-2xl">Choose a service pillar to view options. Book a fixed price instantly or request a tailored quote.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-wrap gap-3 mb-10">
          {pillars.map((p) => (
            <button key={p.id} onClick={() => setActive(p.id)} className={`flex items-center gap-2.5 px-4 py-3 rounded-xl border text-sm font-semibold transition-colors ${active === p.id ? 'bg-[#102d55] text-white border-[#102d55]' : 'bg-white text-slate-700 border-border hover:border-[#1c63c4]'}`}>
              <Icon name={p.icon} className="h-5 w-5" /> {p.name}
            </button>
          ))}
        </div>

        {pillar && (
          <>
            <div className="mb-6"><h2 className="font-display font-bold text-2xl text-[#102d55]">{pillar.name}</h2><p className="text-muted-foreground mt-1">{pillar.blurb}</p></div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {pillar.options.map((o) => (
                <div key={o.id} className="bg-white rounded-2xl border border-border p-6 flex flex-col card-hover">
                  <div className="flex items-start justify-between">
                    <h3 className="font-display font-semibold text-lg text-[#102d55]">{o.name}</h3>
                    <span className={`shrink-0 inline-flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-full ${o.available ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-500'}`}><span className={`h-1.5 w-1.5 rounded-full ${o.available ? 'bg-emerald-500' : 'bg-slate-400'}`} />{o.available ? 'Available' : 'Unavailable'}</span>
                  </div>
                  <p className="text-sm text-muted-foreground mt-2 flex-1">{o.desc}</p>
                  <div className="mt-4 flex items-center gap-2 text-xs text-slate-500"><Icons.Clock className="h-4 w-4" /> {o.duration}</div>
                  <div className="mt-4">
                    {o.price ? <div><span className="text-2xl font-display font-extrabold text-[#102d55]">£{o.price}</span><span className="text-sm text-muted-foreground"> fixed</span></div>
                      : <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#eaf1fb] text-[#1c63c4] text-sm font-semibold"><Icons.Calculator className="h-4 w-4" /> Quote on request</span>}
                  </div>
                  <Button onClick={() => book(o.id)} disabled={!o.available} className="mt-5 w-full bg-[#102d55] hover:bg-[#0b2244] text-white font-semibold">{o.price ? 'Book this service' : 'Request a quote'} <Icons.ArrowRight className="ml-2 h-4 w-4" /></Button>
                </div>
              ))}
            </div>
          </>
        )}
      </section>
      <SiteFooter />
    </div>
  );
};

export default Services;
